import React from 'react';
import { Input, Icon } from 'antd';
import DatePicker from './datepicker';


export default class DatePickerDesignControl extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            bIsNull: props.bIsNull,
            value: null,
            format: props.cFormatData || 'YYYY-MM-DD',
            disabled: false,
            visible: !props.bHidden,
            className: props.className || '',
        };
    }

    componentDidMount() {
        if (this.props.model) {
            this.props.model.addListener(this);
        }
    }
    componentDidUpdate() {
        if (this.props.model)
            this.props.model.addListener(this);
    }
    componentWillUnmount() {
        if (this.props.model)
            this.props.model.removeListener(this);
    }
    onFocus = () => {
        this.props.model.setState('open', true);
    }
    onClear=()=>{
        if(this.props.onChange) this.props.onChange(null);
        if (this.props.model) {
            this.props.model.setValue(null, true);
            // if (this.state.format && this.state.format.indexOf('mm') > -1) return;
            // this.props.model.execute('blur');
        }
    }
    getShowValue = () => {
        const { value } = this.state;
        const { enumArr, enumValue } = this.props;
        let text = value;
        if (enumArr) {
            let val = !cb.utils.isEmpty(enumValue) ? enumValue : value;
            let index = enumArr.findIndex(ele => {
                return val == ele.key;
            })
            if (index != -1) return enumArr[index].value;
        }

        if (cb.utils.isEmpty(value)) text = '';
        return text;
    }
    render() {
        const { visible, err, className } = this.state;
        let style = visible ? {} : { display: "none" };
        let classname = err + ' ' + className;
        let value = this.getShowValue();
        let clearValue = value != '' ? <Icon type="close-circle" onClick={() => this.onClear()} /> : null;
        return (
            <div ref="div" style={style} className={'yxy_datepicker_design  ' + classname}>
                <Input value={value} onFocus={this.onFocus} />
                {clearValue}
                <div style={{ width: '0',marginTop: '-29px' }}><DatePicker inDesign={true} {...this.props} /></div>
            </div>
        );

    }
}



// WEBPACK FOOTER //
// ./src/yxyweb/common/components/basic/datepicker_design.jsx